import script from "./SkuInventoryDecision.vue?vue&type=script&setup=true&lang=js"
export * from "./SkuInventoryDecision.vue?vue&type=script&setup=true&lang=js"

import "./SkuInventoryDecision.vue?vue&type=style&index=0&id=068bf1af&lang=css"

const __exports__ = script;

export default __exports__